import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/workspaceDeveloper/useAdminWorkspaceDeveloperQueryKeys.ts
var t = e("admin-workspace-developer", {
	status: (e) => ["status", e],
	keys: (e) => ["keys", e],
	requests: (e, t) => e === void 0 ? ["requests"] : [
		"requests",
		e,
		...t === void 0 ? [] : [t]
	],
	directory: (e) => e === void 0 ? ["directory"] : ["directory", e]
});
//#endregion
export { t as adminWorkspaceDeveloperQueryKeys };
